import React from 'react';
import { defineMessages, FormattedMessage, FormattedDate } from 'react-intl';
import { DELIVERY_TOOLS } from '@printdeal/business-logic';
import type { SelectedDeliveryTool } from '../../../../../types/file-delivery/FileDelivery';

interface Props {
  cutOffTime: string,
  deliveryDate?: string,
  allowFileDelivery: boolean,
  selectedDeliveryTool: SelectedDeliveryTool,
}

const messages = defineMessages({
  uploader: {
    id: 'product.configurator.cutOffTimeDate_uploader.message',
    defaultMessage: 'If you pay for the order and submit the files <b>before {cutOffTime} today</b>, then the <b>expected delivery date {deliveryDate}</b>',
  },
  alternativeUpload: {
    id: 'product.configurator.cutOffTimeDate_alternativeUpload.message',
    defaultMessage: 'If you pay for the order and submit the files <b>before {cutOffTime} today</b>, then the <b>expected delivery date {deliveryDate}</b>',
  },
  editor: {
    id: 'product.configurator.cutOffTimeDate_editor.message',
    defaultMessage: 'If you pay for the order and finalize your design <b>before {cutOffTime} today</b>, then the <b>expected delivery date {deliveryDate}</b>',
  },
  noFileDelivery: {
    id: 'product.configurator.cutOffTimeDate_noFileDelivery.message',
    defaultMessage: 'If you pay for the order <b>before {cutOffTime} today</b>, then the <b>expected delivery date {deliveryDate}</b>',
  },
});

const getFileDeliveryMessage = (allowFileDelivery: boolean, selectedDeliveryTool: SelectedDeliveryTool) => {
  if (allowFileDelivery) {
    switch (selectedDeliveryTool) {
      case DELIVERY_TOOLS.UPLOADER_TOOL:
        return messages.uploader;
      case 'editor':
        return messages.editor;
      default:
        return messages.alternativeUpload;
    }
  }
  return messages.noFileDelivery;
};

const CutOffTimeText = ({
  cutOffTime,
  deliveryDate,
  allowFileDelivery,
  selectedDeliveryTool,
}: Props) => {
  const { id, defaultMessage } = getFileDeliveryMessage(allowFileDelivery, selectedDeliveryTool);

  const expectedDeliveryDate = deliveryDate && Date.parse(deliveryDate) ? (
    <FormattedDate
      month="long"
      day="numeric"
      weekday="long"
      value={deliveryDate}
    />
  ) : (
    <FormattedMessage
      id="product.configurator.deliveryDate_productionTimeRetrievalError.message"
      defaultMessage="currently unknown"
      description="The expected delivery date is not available at the moment."
    />
  );

  return (
    <FormattedMessage
      id={id}
      defaultMessage={defaultMessage}
      description="The cut off time for a product."
      values={{
        cutOffTime: `${cutOffTime.split(':')[0]}:${cutOffTime.split(':')[1]}`,
        deliveryDate: expectedDeliveryDate,
        b: (chunks: any) => (<b>{chunks}</b>),
      }}
    />
  );
};

export default CutOffTimeText;
